/**
 * PATH: src/pages/pricing/utils/pricingApi.js
 * PURPOSE: Centralized API client for Pricing & Billing module
 */

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "",
});

// Attach JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ----- API Methods ----- //

export const getPlans = (revenueStream) =>
  api
    .get(
      `/api/billing/plans${
        revenueStream ? `?revenueStream=${revenueStream}` : ""
      }`
    )
    .then((r) => r.data);

export const createOrder = (payload, idempotencyKey) =>
  api
    .post(`/api/billing/create-order`, payload, {
      headers: { "Idempotency-Key": idempotencyKey },
    })
    .then((r) => r.data);

export const confirmPayment = (payload) =>
  api.post(`/api/billing/confirm-payment`, payload).then((r) => r.data);

export const getSubscriptions = () =>
  api.get(`/api/billing/subscriptions`).then((r) => r.data);

export const cancelSubscription = (subscriptionId) =>
  api
    .post(`/api/billing/subscriptions/cancel`, { subscriptionId })
    .then((r) => r.data);

export const getTransactions = () =>
  api.get(`/api/billing/transactions`).then((r) => r.data);

export const validateCoupon = (code) =>
  api.post(`/api/billing/coupon/validate`, { code }).then((r) => r.data);

